<ng-container *ngIf="form">
  <div class="prefix-control" style="width: 35%;">
    <tm-select [options]="masters['isdCountryList'] || []" [form_group]="form" [form_control]="isd_formControl"
      title_property="title" id_property="id" float_label="always" [data]="form.value[isd_formControl]"
      [label_overflow]="1" [label]="isd_label |translate" [placeholder]="isd_placeholder| translate"
      [mandatory]="mandatory" [disabled]="disabled">
    </tm-select>
  </div>
  <div class="main-control" style="width: 65%;">
    <app-phone-number [options]="masters['isdCountryList'] || []" [options_data]="form.value[isd_formControl]"
      [form]="form" [controlName]="mobile_number_form_control" [data]="form.value[mobile_number_form_control]"
      [hide_label]="1" [label]="'Number'" [placeholder]="mobile_number_placeholder|translate" [required]="mandatory"
      [readonly]="disabled" [pattern_desc]="'^[0-9]*$'">
    </app-phone-number>
  </div>
</ng-container>
